import { Component, OnInit, Renderer2 } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { PopupService } from '../../../services/popup.service';
import { PopupEnum } from '../../../constants/popup.enum';
import { IGlobalEmployeeInfoModel } from '../../../entities-api/IGlobalEmployeeInfoModel';

@Component({
  selector: 'opm-help-menu',
  templateUrl: './help-menu.component.html',
  styleUrls: ['./help-menu.component.less'],
  standalone: false
})

export class HelpMenuComponent implements OnInit {

  constructor(
    private userService: UserService,
    private renderer: Renderer2,
    private popupService: PopupService
  ) {

    renderer.listen('document', 'click', (event) => {
      if (event.srcElement.id === 'toggle-help-button') {
        return;
      }
      this.popupService.hideAllPopups();
    });
  }

  popupId: string;
  popupVisibility = this.popupService.popupVisibility;
  currentUser: IGlobalEmployeeInfoModel;

  ngOnInit(): void {

  }

  toggleUserMenu = () => {
    this.popupService.togglePopupVisibility(PopupEnum.help);
  }
}
